import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';

const API_TOKEN = environment.apiToken;
const LN_TOKEN = environment.lockersNetToken;
const LN_URL = environment.lockersNet;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private auth = inject(AuthService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (req.url.indexOf(LN_URL) !== -1) {
            req = req.clone({
                headers: req.headers.set('apitoken', LN_TOKEN),
            });
        } else {
            req = req.clone({
                headers: req.headers.set('apitoken', API_TOKEN).set('AccessToken', this.auth.token ?? ''),
            });
        }

        return next.handle(req);
    }
}
